require("../../assets/js/vendor/Modernizr/Modernizr/modernizr.js");
const $ = require('jquery');
window.$ = window.jQuery = $;
require('inputmask/dist/inputmask.js');
require('inputmask/dist/jquery.inputmask.js');
require("jquery-ui-dist/jquery-ui");
require("bootstrap");
$.fn.tooltip.Constructor.DEFAULTS.whiteList['dl'] = [];
$.fn.tooltip.Constructor.DEFAULTS.whiteList['dt'] = [];
$.fn.tooltip.Constructor.DEFAULTS.whiteList['dd'] = [];
const moment = require('moment');
window.moment = moment;
require("select2");
require("malihu-custom-scrollbar-plugin");
import Hammer from 'hammerjs';


// use old cornerstone libraries for now, until we have time to convert to the new versions
window.cornerstone = require("../../assets/js/vendor/chafey/cornerstone/cornerstone.min.js");
window.cornerstoneTools = require("../../assets/js/vendor/chafey/cornerstoneTools/cornerstoneTools.min.js");
window.cornerstoneMath = require("../../assets/js/vendor/chafey/cornerstoneMath/cornerstoneMath.min.js");
window.cornerstoneWebImageLoader = require("../../assets/js/vendor/chafey/cornerstoneWebImageLoader/cornerstoneWebImageLoader.min.js");
window.cornerstoneWADOImageLoader = require("../../assets/js/vendor/chafey/cornerstoneWADOImageLoader/cornerstoneWADOImageLoader.min.js");
// end use old libraries


// uncomment when we want to load the new libraries
// import * as cornerstone from 'cornerstone-core';
// import * as cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
// import * as cornerstoneTools from 'cornerstone-tools';
// import * as cornerstoneMath from 'cornerstone-math';
// window.cornerstone = cornerstone;
// window.cornerstoneWebImageLoader = cornerstoneWebImageLoader;
//
cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.Hammer = Hammer;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
//window.cornerstoneTools = cornerstoneTools;

require("dicom-parser");
require("../../assets/js/vendor/chafey/openjpeg/openJPEG-DynamicMemory-browser.js");
require("../../assets/js/vendor/chafey/charls/charLS-DynamicMemory-browser.js");
require("../../assets/js/vendor/chafey/JPEGLosslessDecoderJS/lossless-min.js");
require("../../assets/js/vendor/Vetology/CountryDependencies/FormatNumberPhone.js");

